import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './HeroContentLayout.module.css';
const formatHeroTitle = (title, titleFirstWordBold) => {
    if (!titleFirstWordBold) {
        return title;
    }
    const words = title.split(' ');
    const [firstWord, ...restWords] = words;
    return (_jsxs(_Fragment, { children: [_jsx("strong", { children: firstWord }), restWords.length > 0 && ' ' + restWords.join(' ')] }));
};
const getHeroContentClassName = (variant) => {
    if (variant === 'accounting') {
        return `${styles.heroContent} ${styles.heroContentAccounting}`;
    }
    return `${styles.heroContent} ${styles.heroContentClient}`;
};
export const HeroLayout = ({ heroImage, children, heroText, variant = 'client' }) => {
    return (_jsxs("div", { className: styles.heroLayout, "data-testid": 'hero-layout', children: [_jsxs("div", { className: styles.heroImageSection, "data-testid": 'hero-image-section', children: [heroImage && _jsx("img", { src: heroImage, alt: 'Hero', className: styles.heroImage, "data-testid": 'hero-image' }), heroText && (_jsxs("div", { className: styles.heroTextOverlay, "data-testid": 'hero-text-overlay', children: [_jsx("h1", { className: styles.heroTitle, "data-testid": 'hero-title', children: formatHeroTitle(heroText.title, heroText.titleFirstWordBold) }), _jsx("p", { className: styles.heroSubtitle, "data-testid": 'hero-subtitle', children: heroText.subtitle })] }))] }), _jsx("div", { className: getHeroContentClassName(variant), "data-testid": 'hero-content', children: children })] }));
};
export const HeroContentLayout = HeroLayout;
